"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var composeFn = function () {
    var fns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i] = arguments[_i];
    }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return fns.forEach(function (fn) { return fn && fn.apply(void 0, args); });
    };
};
exports.composeFn = composeFn;
//# sourceMappingURL=miscHelpers.js.map